import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// Connects to data-controller="slick"
export default class extends Controller {
  slickParams = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3.62,
    swipe: true,
    arrows: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2.62
      }
    }]
  }

  connect = () => $(this.element).slick(this.slickParams)

  disconnect = () => $(this.element).slick('unslick')
}

// NOTE: https://www.jpdevelopment.co.uk/blog/jquery-slick-carousel-turbolinks-initialisation
